import { Fragment, ReactNode } from 'react';
import styled from 'styled-components';

// color: inherit beats the global `* { color }` reset, so marks match light text too
const Footnote = styled.sup`
  font-size: 0.645em;
  line-height: 0;
  color: inherit;
`;

const FOOTNOTE_MARKS = /([®™°*†‡Δ]+)/;

// Superscripts trademark and footnote marks, e.g. "Relief from bloating**°"
export const withFootnotes = (text: string): ReactNode =>
  text
    .split(FOOTNOTE_MARKS)
    .map((part, index) =>
      FOOTNOTE_MARKS.test(part) ? (
        <Footnote key={index}>{part}</Footnote>
      ) : (
        <Fragment key={index}>{part}</Fragment>
      ),
    );
